var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { number, oneOf } from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
var textVariantsModifier = {
  h1: function h1(theme) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.spacing.xxxlarge);
  },
  h2: function h2(theme) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.huge);
  },
  h3: function h3(theme) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.xxxlarge);
  },
  h4: function h4(theme) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.xxlarge);
  },
  h5: function h5() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    height: 28px;\n  "])));
  },
  body1: function body1(theme) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.xlarge);
  },
  body2: function body2(theme) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.large);
  },
  overline: function overline(theme) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.medium);
  },
  exception: function exception(theme) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    height: ", "px;\n  "])), theme.fontSizes.xsmall);
  }
};
var skeletonTypesModifier = {
  circular: function circular() {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n    border-radius: 50%;\n  "])));
  },
  rectangular: function rectangular() {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose([""])));
  },
  text: function text(theme, variant) {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), textVariantsModifier[variant](theme));
  }
};
var StyledSkeleton = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var yoga = _ref.theme.yoga,
      type = _ref.type,
      width = _ref.width,
      height = _ref.height,
      variant = _ref.variant,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'pulse' : _ref$animation;
  return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n\n    width: ", "px;\n    height: ", "px;\n\n    background: ", ";\n\n    ", "\n\n    @keyframes placeholderShimmer {\n      0% {\n        opacity: 0;\n      }\n      50% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0;\n      }\n    }\n\n    ", ";\n  "])), width, height, yoga.colors.clear, animation && css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n      animation: placeholderShimmer 1s linear infinite;\n    "]))), skeletonTypesModifier[type](yoga, variant));
});

function Skeleton(props) {
  return /*#__PURE__*/React.createElement(StyledSkeleton, props);
}

Skeleton.propTypes = {
  /**
   * Determines which type will be rendered. It can be
   * 'circular', 'rectangular' or 'text'.
   */
  type: oneOf(['circular', 'rectangular', 'text']).isRequired,

  /**
   * Determine the width of the skeleton.
   * Applicable to all variants.
   */
  width: number.isRequired,

  /**
   * Determine the height of the skeleton.
   * Applicable only to circular and rectangular variants.
   */
  height: number.isRequired,

  /**
   * Determine if the animation will 'pulse' or false;
   */
  animation: oneOf(['pulse', false])
};
Skeleton.defaultProps = {
  animation: 'pulse'
};
export default Skeleton;